import React from "react";
import MainFrame from "../../components/mainFrame";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import Navbar from "../../components/navbar";
import { Helmet } from "react-helmet";
import TextContainer from "../../components/Texts/TextContainer";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Dashboard() {
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> داشبورد | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="داشبورد" />
      <TextContainer>داشبورد خالی است!</TextContainer>
    </Container>
  );
}

export default MainFrame(Dashboard);
